import React from "react";
import { Outlet } from "react-router-dom";
import Layout from "./Layout";
import { ClientsDataProvider } from "../../context/ClientsDataContext";

const MainLayout = () => {
  return (
    <ClientsDataProvider>
      <Layout>
        <Outlet />
      </Layout>
    </ClientsDataProvider>
  );
};

export default MainLayout;
